import './DisplayEvent.css';
import {useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {deleteAttendee} from '../Services/CallService';
import DataTable from "react-data-table-component";
import SortIcon from "@mui/icons-material/ArrowDownward";
import DeleteIcon from '@mui/icons-material/Delete';
//Added by Sarah 
import {useAuth} from "../Contexts/AuthContexts"
import Topbar from '../Components/Topbar'
import {CALL_API_URL} from '../Services/CallService'
import {useData} from  "../Contexts/DataContext"



function DisplayEvent() {
  const navigate = useNavigate();
  const [event, setEvent] = React.useState([])
  const [status, setStatus] = React.useState();
  //Added by Sarah 
  const collector = useData();
  const provider = useAuth();
  const [filter, setFilter] = React.useState("All");
  const eventsPage = () => {
    navigate("/UserHome")
  }


  async function handleRsvp() {
    //post status and user info to backend here
    let response = {};
    let editStatus = false;
    let preventRSVP = false;
    if (event.attendees != null) {
      event.attendees.map(attendee => {
        if (attendee.email == provider.currentUser.email) {
          if (status == attendee.status) {
            alert("You have already rsvp'd under that status")
            preventRSVP = true;
            return;
          } else {
            deleteAttendee(attendee.id, event.eventID, event.host, provider.currentUser.email, attendee.email)
            editStatus = true;
          }
        }
      })
    } 
    if (event.inviteOnly == "true" && preventRSVP == false) {
      if (collector.user.userType === "teacher" || collector.user.userType === "organizer" || event.host === provider.currentUser.email) {
        editStatus == false ? alert("You have rsvp'd!") : alert("You have edited your rsvp!")
        response = await fetch(`${CALL_API_URL}/api/events/${eventID}/${collector.user.id}/${status}`, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify()
       })
       await collector.refresh();
    } else {
        alert("This event is invite only!")
        return;
      }
    } else if (preventRSVP == false){
      editStatus == false ? alert("You have rsvp'd!") : alert("You have edited your rsvp!")
        response = await fetch(`${CALL_API_URL}/api/events/${eventID}/${collector.user.id}/${status}`, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
      body: JSON.stringify()
    })
    }
    await collector.refresh();
    return response.json();
  }

  function updateStatus(event) {
    const { value } = event.target
    setStatus(value);
  }
  
  function updateFilter(event) {
    const { value } = event.target
    setFilter(value);
  }

  const { eventID } = useParams(); //get eventID from path

  useEffect(() => {
    collector.data.forEach(event => {
        if (event.eventID == eventID) {
          setEvent(event); //set current event
        }
      });
  });


  const customStyles = {
    rows: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
        borderRadius: "0px",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
        fontFamily: "Avenir Next",
        fontStyle: "semibold",
        fontSize: "11px",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
        fontFamily: "Avenir Next",
      },
    },
  };

  return (
    <div className=' bg-[#F7F8FC] w-[100%] overflow-y-scroll rounded-xl'>
      <Topbar />
      <div className="bg-white px-[3%] mx-[8%] py-[1%] mb-[2%] mt-[2%]">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-[28px] font-semibold leading-6 text-gray-900">{event.eventName}</h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">See event details below.</p>
        </div>
      </div>
      <div className="bg-white px-[3%] mx-[8%] py-[1%] mb-[2%] mt-[0%]">
        <div className="border-gray-200">
          <dl>
            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-semibold text-gray-500">ID</dt>
              <dd className="font-light text-sm text-gray-900 sm:col-span-2 sm:mt-0">{event.eventID}</dd>
            </div>
            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-semibold text-gray-500">HOST</dt>
              <dd className="font-light text-sm text-gray-900 sm:col-span-2 sm:mt-0">{event.host}</dd>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-semibold text-gray-500">LOCATION</dt>
              <dd className="font-light text-sm text-gray-900 sm:col-span-2 sm:mt-0">{event.location}</dd>
            </div>
            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-semibold text-gray-500">TIME</dt>
              <dd className="font-light text-sm text-gray-900 sm:col-span-2 sm:mt-0">{event.time}</dd>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-semibold text-gray-500">DATE</dt>
              <dd className="font-light text-sm text-gray-900 sm:col-span-2 sm:mt-0">{event.date}</dd>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-semibold text-gray-500">DESCRIPTION</dt>
              <dd className="font-light  text-sm text-gray-900 sm:col-span-2 sm:mt-0">{event.description}</dd>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-semibold text-gray-500">CAPACITY</dt>
              <dd className="font-light text-sm text-gray-900 sm:col-span-2 sm:mt-0">{event.capacity}</dd>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-semibold text-gray-500">INVITE ONLY</dt>
              <dd className="font-light text-sm text-gray-900 sm:col-span-2 sm:mt-0">{event.inviteOnly}</dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="bg-white px-[3%] mx-[8%] pt-[1%] pb-[4%] mb-[5%] mt-[2%]">
        <div className="mt-[15px] pt-[10px] mx-[0%]">
          <p className="text-black font-semibold text-[24px] ml-[0%] pb-[5px]">Attendees</p>
          {event.attendees != null ? <p className="mt-0 max-w-2xl text-lg font-medium text-gray-900">Number of attendees: {JSON.parse(JSON.stringify(event.attendees)).filter((attendee) => attendee.status === "Will Attend").length}</p> : <p className="mt-0 max-w-2xl text-lg font-medium text-gray-900">Number of attendees: 0</p>}
        </div>

        <div className="form--role">
          <label className="mt-0 max-w-2xl text-lg font-medium text-gray-900" htmlFor="rsvpStatus">Filter by status: </label>
          <br />
          <select
            id="filterStatus"
            value={filter}
            onChange={updateFilter}
            name="filter"
            className="form--marketing"
          >
            <option value="All">All</option>
            <option value="Will Attend">Will Attend</option>
            <option value="Maybe">Maybe</option>
            <option value="Won't Attend">Won't Attend</option>
            <option value="I'm Your Nemesis">I'm Your Nemesis</option>
          </select>
        </div>

        <div>
         <DataTable
            customStyles={customStyles}
            columns={
              [
                {
                  name: "EMAIL",
                  selector: "email",
                  sortable: true,
                },
                {
                  name: "STATUS",
                  selector: "status",
                  sortable: true,
                },
                {
                  name: "ACTIONS",
                  selector: "null",
                  sortable: false,
                  cell: (attendee) => [
                    <>
                      <div>
                      <button id={attendee.id} className='mx-[5px]' onClick={async (e) => {
                          await deleteAttendee(e.currentTarget.getAttribute("id"), event.eventID, event.host, provider.currentUser.email, attendee.email)
                          await collector.refresh()
                        }}>
                          <DeleteIcon fontSize="small" style={{ color: '#5A5A5A' }} />
                        </button>
                      </div>
                    </>

                  ]
                },
              ]
            }
            data={event.attendees != null ? (filter == "All" ? event.attendees: JSON.parse(JSON.stringify(event.attendees)).filter((attendee) => attendee.status === filter)): []} //fill attendees data here
            defaultSortField="title"

            sortIcon={<SortIcon />}
            striped
            pagination
          /> 
        </div>
        <div>
        <p className="text-black font-semibold ml-[0%] pb-[15px]">Your RSVP: {status}</p>
      </div>

      <div>
        <div>
        {collector.user.id != undefined && <button className="rsvpButton" onClick={handleRsvp}>RSVP</button>}

        <div className="form--role">
          <label className="form--roleName" htmlFor="rsvpStatus">What is your status?</label>
          <br />
          <select
            id="rsvpStatus"
            value={status}
            onChange={updateStatus}
            name="status"
            className="form--marketing"
          >
          
            <option></option>
            <option value="Will Attend">Will Attend</option>
            <option value="Maybe">Maybe</option>
            <option value="Won't Attend">Won't Attend</option>
            <option value="I'm Your Nemesis">I'm Your Nemesis</option>
          </select>
        </div>

        <button className="backButton" onClick={eventsPage}>Back</button>
      </div>
      </div>
      </div>
    </div>
  );
}

export default DisplayEvent;